define(function (require) {
	// general
	const Backbone = require('backbone');
	const Modal = require('backbone.modal');
	const Radio = require('backbone.radio');
	const AddInvitationChannel = Radio.channel('addInvitationChannel');
	const ViewManager = require('civicsUtils/view_manager');
	// models
	const invitation_model = require('civicsModels/portal/invitation_model');

	// templates
	const AddInvitationTemplate = require('civicsViews/InviteApplicant/templates/t_cpv_invite_applicant.hbs');
	// views
	const rowView = require('civicsViews/InviteApplicant/v_itv_invite_applicant');
	// start here invitations
	const applicant_model = require('civicsModels/applicant_model');
	const Utils = require('civicsUtils/general_utilities');
	const constants = require('civicsUtils/constants');
	const LiveRegion = require('civicsUtils/live_region_utility');

	return Marionette.CompositeView.extend({
		initialize: function (options) {
			this.config = options.config ? options.config : {};
			this.modalRegion = options.modalRegion;
			this.additionalCapacityTypes = options.additionalCapacityTypes;
			this.applicantTypes = options.applicantTypes;
			this.setApplicantConfig();
			this.collection = options.collection,
			this.isAddProcess = options.isAddProcess,
			this.addInvitation();
			if (options.primaryApplicant) {
				this.primaryApplicant = options.primaryApplicant;
			}
		},
		capacityCodes: function() {
			if(this.config.showCapacity){
				return this.additionalCapacityTypes.toJSON();
			}
		},
		showApplicantType: function() {
			if (this.config.instrumentType.toLowerCase() == "tradelicense") {
				return false;
			}
			return this.config.showApplicantType;
		},
		childViewOptions:function(model, index){
			  var self = this;
				return {
					requireCapacity: self.config.requireCapacity,
					capacityCodes: self.capacityCodes(),
					applicantTypes: self.applicantTypes,
					instrumentType: this.config.instrumentType.toLowerCase(),
					showCapacity: self.config.showCapacity,
					showApplicantType: self.showApplicantType(),
					config: this.config
				}
		},
		template: AddInvitationTemplate,
		childView: rowView,
		childViewContainer: '.invitation-items',
		childEvents: {
			'invitations:post:save': 'onPostSaveInvitation',
			'invitation-item:remove': 'onRemoveInvitationItem',
		},
		ui: {
			//start HERE
			capacitySelect: '#capacity-type',
			newButton: '.invitations-add-new .btn-secondary',
			saveButton: '.save-invite',
			cancelButton: '.cancel-invite',
			listViewerHeader: '.list-view-header',
			inviteApplicantsSection: '.invite-applicants-section'
		},
		events: {
			'click @ui.newButton': 'addInvitation',
			'click @ui.saveButton': 'onSaveNewInvitations',
			'click @ui.cancelButton': 'closeInviteApplicantModal',
			'click .bbm-btn-close': 'closeInviteApplicantModal',
		},
		onShow: function () {

		},

		onRender: function(){
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInitCivics();
			this.$el.rhythmThemeInit();
			this.setupFilterCodes(this.config.instrumentType);


			if(this.config.showCapacity && this.additionalCapacityTypes && this.additionalCapacityTypes.length >1) {
				this.ui.inviteApplicantsSection.addClass('show-capacity');
			}

			if(this.showApplicantType()) {
				this.ui.inviteApplicantsSection.addClass('show-applicant-type');
			}

			ViewManager.resetErrorMessages(this);

		},
		setApplicantConfig: function(){
			this.config.showApplicantType = this.config.globalConfig.usesApplicantType == 'Show';
			this.config.showCapacity = this.config.globalConfig.usesCapacity != 'Hide';
			this.config.requireCapacity = this.config.globalConfig.usesCapacity == 'Required';
		},
		addInvitation: function () {
			var mod = new invitation_model();
			var id = this.collection.length + 1;
			// preserve changes made since render will erase them
			_.each(this.collection.models, function(model) {
				var view = this.children.findByModel(model);
				var data = view.getData(null);
				this.setModel(model, data);
				id = model.id >= id ? model.id + 1 : id;
			}, this);

			var dataRow = {
				id: id,
				applicantType: { code: '' },
				capacity: '',
				sendTo: '',
			};
			mod.set(dataRow);
			mod.id = id;

			this.collection.add(mod);
			this.render();

			// On initial render (modal first opening), don't steal focus —
			// let modal_region.trapFocus handle it so screen reader announces the dialog
			if (this._initialized) {
				// Immediately focus the modal dialog to prevent screen reader from escaping during re-render
				var $dialog = this.$el.closest('[role="dialog"]');
				if ($dialog.length) {
					$dialog.focus();
				}

				// Restore focus to the first focusable field of the newly added row
				this.restoreFocusToLastRow();

				// Announce new invite row added to assistive technology
				var inviteCount = this.collection.length;
				LiveRegion.announcePolite(i18n.t('CIVICS.COMMON_INVITE_APPLICANT.INVITE_ADDED_ANNOUNCE', {count: inviteCount}));
			}
			this._initialized = true;
		},
		setModel: function(model, data) {
			// update model with input data
			var dataobj = {
				"applicantType": {
					"code": data.applicantType.code,
					"description": data.applicantType.description
				},
				"capacity": {
					"code": data.capacity.code,
					"description": data.capacity.description
				},
				"id": model.id,
				"isValid": data.isValid,
				"sendTo": data.sendTo
			};
			model.set(dataobj);
		},
		onSaveNewInvitations: function (data, model) {
			ViewManager.resetErrorMessages(this);
			ViewManager.loading(true);
			var newInvitations = [];
			var errorsFound = false;
			this.addInvitePromise = $.Deferred();

			// save invitation item(s)
			var self = this;
			self.children.each(function (view, index) {
				var data = view.getData(self.primaryApplicant);
				if(self.config.instrumentType.toLowerCase() != 'tradelicense' && self.config.showApplicantType == true)
					data.applicantType.code = Utils.getApplicantType(self.config.instrumentType, data.applicantType.code);
				if(!data.isValid){
					errorsFound = true;
				} else {
					if (self.isAddProcess) {
						newInvitations.push({
							sendTo: data.sendTo,
							capacity: data.capacity,
							applicantType: data.applicantType,
						});
					}
					else {
						newInvitations.push({
							isExpired: false,
							sendTo: data.sendTo,
							capacity: data.capacity,
							applicantType: data.applicantType,
							productFamily: self.config.fromServer.instrumentType,
							instrumentNumber: self.config.fromServer.instrumentID,
						});
					}
				}
			});

			if(errorsFound) {
				// Focus the first error field across all rows
				ViewManager.focusError(this);
				ViewManager.loading(false);
				return;
			}

			// if not in Add Instrument, save each invite and send
			if (!self.isAddProcess) {
				newInvitations = self.saveInvitations(newInvitations);
			}
			else {
				self.addInvitePromise.resolve();
			}

			$.when(self.addInvitePromise).done(function(){
				if(!self.isAddProcess) {
					Utils.civicsToastPop( i18n.t('CIVICS.COMMON_INVITE_APPLICANT.SINGLE_INVITE_APPLICANT_UPDATED_SUCCESS'), "success");
				}

				// add new invitation models in the layout view
				self.triggerMethod('invitation:added', newInvitations);
				self.closeInviteApplicantModal();
				ViewManager.loading(false);

				//reloads page after sending invite in instrument details
				if (!self.isAddProcess) window.location.reload(false);
			});
		},
		saveInvitations: function(newInvitations){
			var self = this;
			var promises = [];

			_.each(newInvitations, (invite) => {
				var def = new $.Deferred();
				var invitationModel = new invitation_model();
				invitationModel.set("sendTo", invite.sendTo);
				invitationModel.set("applicantType", invite.applicantType.code);
				invitationModel.set("capacity", invite.capacity.code);
				invitationModel.set("instrumentNumber", invite.instrumentNumber);
				invitationModel.set("productFamily", invite.productFamily);
				invitationModel.save(null, {
 					 // type: 'PUT',
					 success: function (model, response, options) {
						 invite.id = model.get("id");
						 invite.sender = model.get("sender");
						 invite.expiredDate = model.get("expiredDate");
						 invite.sentDateTime = model.get("sentDateTime");
						 invite.isExpired = false;
						 def.resolve();
					 },
					 error: function (model, response, options) {
						 def.reject();
						 let alertMessage = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.ERROR_SAVING_INVITATIONS');
						 if(response.responseJSON && response.responseJSON.responseStatus && response.responseJSON.responseStatus.errorCode == "403")
						 {
							alertMessage = i18n.t('CIVICS.COMMON_INVITE_APPLICANT.CAPACITY_NOT_AVAILABLE',{capacity: response.responseJSON.responseStatus.message});
						 }
						 ViewManager.loading(false);
						 ViewManager.openAlert(alertMessage);
					 },
			 	 });
			 promises.push(def);
			});

			$.when.apply($, promises).done(function (response, status, xhrResponse) {
				self.addInvitePromise.resolve();
			}).fail(function (response, status, xhrResponse) {
			});

			return newInvitations;
		},
		onRemoveInvitationItem: function (childView) {
			var removedIndex = this.collection.indexOf(childView.model);
			this.collection.remove(this.collection.get({cid: childView.model.cid}));

			this.removeChildView(childView);
			childView.destroy();

			this.ui.saveButton.prop("disabled", (this.collection.length <= 0));

			// Announce removal to assistive technology
			var remaining = this.collection.length;
			LiveRegion.announcePolite(i18n.t('CIVICS.COMMON_INVITE_APPLICANT.INVITE_REMOVED_ANNOUNCE', {count: remaining}));

			// Restore focus to the nearest remaining row or the Add button
			this.restoreFocusAfterRemove(removedIndex);
		},
		/**
		 * After render from addInvitation, move focus to the first focusable
		 * input in the last (newly added) invitation row.
		 */
		restoreFocusToLastRow: function () {
			var self = this;
			setTimeout(function () {
				var $lastRow = self.$('.invitation-item:last');
				if ($lastRow.length) {
					var $focusTarget = $lastRow.find('input:visible, select:visible, button:visible, [tabindex="0"]').first();
					if ($focusTarget.length) {
						$focusTarget.focus();
					} else {
						$lastRow.find('.remove-invitation').focus();
					}
				}
			}, 300);
		},

		/**
		 * After removing an invitation row, move focus to the delete button
		 * of the nearest remaining row, or to the Add button if none remain.
		 */
		restoreFocusAfterRemove: function (removedIndex) {
			var self = this;
			setTimeout(function () {
				var $rows = self.$('.invitation-item');
				if ($rows.length === 0) {
					// No rows left — focus the "Add" button
					self.ui.newButton.focus();
				} else {
					// Focus the row at the same index, or the last one if we removed the last
					var targetIndex = Math.min(removedIndex, $rows.length - 1);
					var $targetRow = $rows.eq(targetIndex);
					var $focusTarget = $targetRow.find('.remove-invitation');
					if ($focusTarget.length) {
						$focusTarget.focus();
					} else {
						$targetRow.find('input:visible, select:visible, button:visible').first().focus();
					}
				}
			}, 100);
		},

		closeInviteApplicantModal: function (e, myModel) {
			if(this.modalRegion) {
				this.modalRegion.hideModal();
			} else {
				this.destroy();
			}
		},
		templateHelpers: function () {
			var self = this;
			var instType = self.config.instrumentType;

			return {
				config: this.config,
				requireCapacity: this.config.requireCapacity,
				showCapacity: (this.config.showCapacity && this.additionalCapacityTypes && this.additionalCapacityTypes.length > 1) ? true : false,
				showApplicantType: this.config.showApplicantType,
				showApplicantType: function () {
					if (this.config.instrumentType.toLowerCase() == "tradelicense") {
						return false;
					}

					return this.config.showApplicantType;
				},
				addInviteBtnText: function () {
					if (self.isAddProcess) {
						return i18n.t('CIVICS.COMMON_INVITE_APPLICANT.ADD_NEW_INVITE');
					} else {
						return i18n.t('CIVICS.COMMON_INVITE_APPLICANT.ADD_AN_INVITE');
					}
				},
				saveSendBtnText: () => {
					if (this.isAddProcess) {
						return i18n.t('CIVICS.COMMON.SAVE');
					} else {
						return i18n.t('CIVICS.COMMON_INVITE_APPLICANT.SEND');
					}
				},
			};
		},
	});
});
